import Joi from '@hapi/joi'

export const DivisionSummaryReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Select Operation Entity`,
        "any.required": `Operation Entity required`
    }),
    divisionID: Joi.number().optional().label("Collection Point").messages({
        "any.invalid": `Select Collection Point`,
        "any.required": `Collection Point required`
    }),
    modeID: Joi.number().label("Mode").messages({
        "any.invalid": `Select Mode`,
        "any.required": `Mode required`
    }),
    typeID: Joi.string().label("Type").messages({
        "any.invalid": `Select Type`,
        "any.required": `Type required`
    }),
    toDate: Joi.string().invalid("").required().label("To Date").messages({
        "any.invalid": `To Date required`,
        "any.required": `To Date required`
    }),
    fromDate: Joi.string().invalid("").required().label("From Date").messages({
        "any.invalid": `From Date required`,
        "any.required": `From Date required`
    })
}
